<div class="modal-header">
  <h5 class="modal-title text-dark">{{ title }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body p-0">
  <ng-container *ngIf="previewUrl; else noUrl">
    <iframe
      [src]="previewUrl"
      title="{{ title }}"
      class="google-storage-preview-iframe"
      frameborder="0"
    ></iframe>
  </ng-container>
  <ng-template #noUrl>
    <div class="preview-empty">
      <p>No se ha proporcionado una URL válida para visualizar.</p>
    </div>
  </ng-template>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">
    Cerrar
  </button>
  <a
    *ngIf="signedUrl"
    [href]="signedUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="btn btn-primary"
  >
    Abrir en nueva pestaña
  </a>
</div>
